import { forwardRef, type SVGProps } from 'react';

export const ExcelIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  function ExcelIcon(props, ref) {
    return (
      <svg
        ref={ref}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_530_604)">
          <path
            d="M21.26 12.8179H17.4431V10.9094H21.26V12.8179ZM21.26 13.9084H17.4431V15.8169H21.26V13.9084ZM21.26 4.9115H17.4431V6.81992H21.26V4.9115ZM21.26 7.91047H17.4431V9.81889H21.26V7.91047ZM21.26 16.9074H17.4431V18.8158H21.26V16.9074ZM23.8964 20.6697C23.7873 21.2368 23.1057 21.2504 22.6504 21.2696H14.1715V23.7232H12.4785L0 21.5421V2.46055L12.5521 0.276733H14.1715V2.44962H22.3587C22.8195 2.4687 23.3266 2.43598 23.7273 2.71133C24.0082 3.11483 23.9809 3.62741 24 4.09086L23.9891 18.2842C23.9755 19.0775 24.0627 19.8873 23.8964 20.6697ZM9.99745 16.3921C9.24502 14.8654 8.47894 13.3495 7.72917 11.8227C8.47073 10.3369 9.20142 8.84562 9.92934 7.3543C9.31045 7.3843 8.69156 7.42245 8.07544 7.46609C7.61466 8.58659 7.07756 9.67714 6.7177 10.8358C6.38236 9.74258 5.93798 8.69019 5.53177 7.6242C4.93195 7.65692 4.33214 7.69236 3.73238 7.7278C4.36486 9.12373 5.03831 10.5005 5.65172 11.9045C4.92923 13.2677 4.25311 14.65 3.55242 16.0213C4.14947 16.0459 4.74656 16.0704 5.34361 16.0786C5.76895 14.9935 6.29784 13.9493 6.66863 12.8424C7.00125 14.0311 7.56558 15.1298 8.02908 16.2667C8.68612 16.3131 9.34041 16.354 9.99745 16.3921ZM22.6997 3.74445H14.1715V4.9115H16.3526V6.81992H14.1715V7.91047H16.3526V9.81889H14.1715V10.9094H16.3526V12.8179H14.1715V13.9084H16.3526V15.8169H14.1715V16.9074H16.3526V18.8158H14.1715V20.0766H22.6997V3.74445Z"
            fill="#18884F"
          />
        </g>
        <defs>
          <clipPath id="clip0_530_604">
            <rect fill="white" height="24" width="24" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);
